(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-related-colors"] && !Shopify.designMode) return;
  try {
    // Toggle the extra related colors on product cards (event delegation, works with filtered/paginated collections)
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-card-colors-toggle]');
    if (!button) return;

    // The card has a full-card link overlay, don't navigate
    event.preventDefault();
    event.stopPropagation();

    const extra = button.closest('.card-colors').querySelector('.card-colors__extra');
    if (!extra) return;

    const expanded = button.getAttribute('aria-expanded') === 'true';
    extra.hidden = expanded;
    button.setAttribute('aria-expanded', String(!expanded));
    button.innerHTML = expanded ? button.dataset.labelMore : button.dataset.labelLess;
  });
  } catch(e) { console.error(e); }
})();

})();
